module.exports = __webpack_public_path__ + "static/media/lidcore-cases-1.cbd3e303.png";